export default __webpack_public_path__ + "static/media/4.604e2e90.svg";